import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/operator/dashboard')({
  beforeLoad: () => {
    throw redirect({ to: '/operator' });
  },
});
